import styled, { css } from "styled-components";

export type SpacingProps = {
  t?: number;
  r?: number;
  b?: number;
  l?: number;
};

const spacingStyle = css<SpacingProps>`
  ${({ t }) => t && `margin-top: ${t}px;`}
  ${({ r }) => r && `margin-right: ${r}px;`}
  ${({ b }) => b && `margin-bottom: ${b}px;`}
  ${({ l }) => l && `margin-left: ${l}px;`}
`;

export const Spacing = styled.div<SpacingProps>`
  ${spacingStyle}
`;
